import { EnterOTPCodeInitialFormValues } from './types';

export const initialValues: EnterOTPCodeInitialFormValues = {
  otp: '',
};
